import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Callback } from 'Types/utilTypes'
import { Id } from 'Types/aliases'
import { AdvertisingDataModel } from 'Src/modules'

export namespace AdvertisingNS {
	export type UpdateAdvertising = PayloadAction<{
		callback?: Callback
		data: AdvertisingDataModel
		id: Id
	}>
}

export const advertisingSlice = createSlice({
	name: 'advertising',
	initialState: {},
	reducers: {
		updateAdvertising: (state, action: AdvertisingNS.UpdateAdvertising) => {},
	},
})
